// extracted by mini-css-extract-plugin
export default {"background":"Home_background__R9LIT","imageSearching":"Home_imageSearching__Q6Mlr","loading":"Home_loading__+5cVQ"};